module.exports = __webpack_public_path__ + "img/qrcode_for_gh_2fa43fba8d33_258.ae04ae2a.jpg";